'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.constants = undefined;

var _bitEntrophy = require('./bit-entrophy');

var _bitEntrophy2 = _interopRequireDefault(_bitEntrophy);

var _strengthConstants = require('./strength-constants');

var strengthConstants = _interopRequireWildcard(_strengthConstants);

var _numericOrdinalPenalty = require('./numeric-ordinal-penalty');

var _numericOrdinalPenalty2 = _interopRequireDefault(_numericOrdinalPenalty);

var _alphaOrdinalPenalty = require('./alpha-ordinal-penalty');

var _alphaOrdinalPenalty2 = _interopRequireDefault(_alphaOrdinalPenalty);

var _efficiency = require('./efficiency');

var _efficiency2 = _interopRequireDefault(_efficiency);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ENTROPHY_WEAK = 45;
var ENTROPHY_ADAQUATE = 90;

var constants = exports.constants = strengthConstants;

var calculatePenalizedBitEntrophy = function calculatePenalizedBitEntrophy(scaledBitEntrophy, passwordUnderTest) {
    var penalizedBitEntrophy = scaledBitEntrophy;

    var penaltyAppliers = [_numericOrdinalPenalty2.default, _alphaOrdinalPenalty2.default];
    penaltyAppliers.forEach(function (penaltyApplier) {
        var penaltyPercentage = penaltyApplier(passwordUnderTest);
        penalizedBitEntrophy = penalizedBitEntrophy - scaledBitEntrophy * penaltyPercentage;
    });
    return penalizedBitEntrophy;
};

exports.default = {
    validateStrength: function validateStrength(password) {
        var perCharacterBitEntrophy = (0, _bitEntrophy2.default)(password),
            scaledBitEntrophy = (0, _efficiency2.default)(perCharacterBitEntrophy, password),
            penalizedBitEntrophy = calculatePenalizedBitEntrophy(scaledBitEntrophy, password);
        if (penalizedBitEntrophy < ENTROPHY_WEAK) {
            return constants.WEAK;
        } else if (penalizedBitEntrophy < ENTROPHY_ADAQUATE) {
            return constants.ADAQUATE;
        } else if (penalizedBitEntrophy >= ENTROPHY_ADAQUATE) {
            return constants.STRONG;
        }
    },
    constants: constants
};
//# sourceMappingURL=index.js.map